import { client, rawClient } from '../../../../ajax';
import formatError from '../../../../formatErrors';
import {
  sendingRequest,
  receivedResponse,
  createAction,
} from '../../../../redux_util';

export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

export const forgotPassswordSuccess = createAction(
  FORGOT_PASSWORD_SUCCESS,
  'message'
);
export const forgotPassword = data => {
  return dispatch => {
    dispatch(sendingRequest('forgotPassword'));
    return rawClient
      .post('forgotpassword', data)
      .then(res => {
        dispatch(receivedResponse('forgotPassword'));
        return dispatch(forgotPassswordSuccess(res.data));
      })
      .catch(err => {
        return dispatch(receivedResponse('forgotPassword', formatError(err)));
      });
  };
};

export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';

export const resetPassswordSuccess = createAction(
  RESET_PASSWORD_SUCCESS,
  'message'
);
export const resetPassword = data => {
  return dispatch => {
    dispatch(sendingRequest('resetPassword'));
    return client
      .post('resetpassword', data)
      .then(res => {
        dispatch(receivedResponse('resetPassword'));
        return dispatch(resetPassswordSuccess(res.data));
      })
      .catch(err => {
        return dispatch(receivedResponse('resetPassword', formatError(err)));
      });
  };
};



// WEBPACK FOOTER //
// ./src/components/screens/ForgotPassword/redux/actions.js